import React, { useState, useEffect } from "react";

import { ResourceStates } from "../../Helpers/DataDefinitions";
import type { ResourceState } from "../../Helpers/DataDefinitions/ResourceStates";

// Taking an async function
// const SomeOtherComponent = () => {
//   const [data, setData] = useState()
//   const loadingState = useLoadingState(fetchSomeStuff, [])
//   return (
//     <LoadingPage loadingState={loadingState}>
//       <div> This is a page </div>
//     </LoadingPage>
//   );
// };
//
// Taking an anonymous async function
// const SomeOtherComponent = () => {
//   const [data, setData] = useState()
//   const loadingState = useLoadingState(async () => {
//     const data = await fetchSomeStuff();
//     await otherFetch();
//     setData(data)
//   }, []);
//   return (
//     <LoadingPage loadingState={loadingState}>
//       <div> This is a page </div>
//     </LoadingPage>
//   );
// };

export const useLoadingState = (
  onLoad: () => Promise<any>,
  condition: any,
): ResourceState => {
  const [loadingState, setLoadingState] = useState<ResourceState>(
    ResourceStates.unloaded,
  );
  const trackLoading = async () => {
    try {
      setLoadingState(ResourceStates.unloaded);
      await onLoad();
      setLoadingState(ResourceStates.loaded);
    } catch (error) {
      console.error(error);
      setLoadingState(ResourceStates.error);
    }
  };
  useEffect(() => {
    trackLoading();
  }, condition);
  return loadingState;
};

interface LoadingStateProps {
  children?: React.ReactNode;
  render?: () => React.ReactNode;
  loadingState: ResourceState;
}

export const WithLoadingComponent = <P,>(
  LoadingComponent: React.ComponentType<P>,
  ErrorLoadingComponent: React.ComponentType,
) => {
  const LoadingState = ({
    children,
    render,
    loadingState,
    ...props
  }: LoadingStateProps & P) => {
    const componentProps: P = props as P;
    if (loadingState === ResourceStates.error) {
      return <ErrorLoadingComponent {...props} />;
    }
    if (
      loadingState === ResourceStates.loading ||
      loadingState === ResourceStates.unloaded
    ) {
      return <LoadingComponent children={null} {...componentProps} />;
    }
    if (children != undefined) {
      return <>{children}</>;
    } else if (render != undefined) {
      return <>{render()}</>;
    } else {
      return null;
    }
  };
  return LoadingState;
};
